import { BaseAction } from '@mihanizm56/redux-core-modules';

export const FETCH_LOGIN_NAVIGATION = '@root/FETCH_LOGIN_NAVIGATION';
export const fetchLoginNavigationActionSaga: BaseAction = () => ({
  type: FETCH_LOGIN_NAVIGATION,
});
